// src/contexts/LanguageContext.jsx
import React, { createContext, useState, useContext } from 'react';


// export the context itself
export const LanguageContext = createContext();

 export function LanguageProvider({ children }) {
   const [lang, setLang] = useState('en');
   const toggleLanguage = () => setLang(prev => (prev === 'en' ? 'fr' : 'en'));

   return (
    <LanguageContext.Provider value={{ lang, toggleLanguage }}>
       {children}
     </LanguageContext.Provider>
   );
 }

 export function useLanguage() {
   return useContext(LanguageContext);
 }